import React from 'react'
import { IconFilter, IconX, IconPlus } from '@tabler/icons-react'

import './FilterPillAction.scss'

// This file is not easy to understand
export const FilterPillAction = ({
  customFilterIcon,
  showAllOnEmpty,
  handleRemoveFilter,
  hasSelection,
  isClearable,
  loading = false,
}) => {
  const determineIcon = () => {
    if (hasSelection || showAllOnEmpty) {
      if (isClearable) {
        return (
          <>
            {customFilterIcon ? (
              React.cloneElement(customFilterIcon, {
                className: 'hack-filter-icon',
                'data-testid': 'custom-filter-icon',
              })
            ) : (
              <IconFilter className="hack-filter-icon" data-testid="view-filter-icon-with-clear" />
            )}
            <IconX className="hack-x-icon" data-testid="clear-filter-icon" />
          </>
        )
      }
      return customFilterIcon ? (
        React.cloneElement(customFilterIcon, { className: 'view-filter-icon' })
      ) : (
        <IconFilter data-testid="view-filter-icon" />
      )
    }

    return <IconPlus data-testid="add-filter-icon" />
  }

  // Making this a div instead of a button because the console will complain about nested buttons
  return (
    <>
      {isClearable && hasSelection ? (
        <div
          disabled={loading}
          data-testid="clear-filter-button"
          className="filter-pill-action clear-filter-button"
          onClick={(event) => {
            event.stopPropagation()

            if (!loading) {
              handleRemoveFilter(event)
            }
          }}
        >
          {determineIcon()}
        </div>
      ) : (
        <div className="filter-pill-action">{determineIcon()}</div>
      )}
    </>
  )
}
